import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import * as React from 'react';

const Wrapper = styled('div')`
  padding: ${(props) => `${props.theme.spacing(0.25)} ${props.theme.spacing(4)}`};
  background: ${(props) => props.theme.palette.common.white};
`;

const Footer = () => (
  <Wrapper>
    <Grid
      container
      spacing={0}
    ></Grid>
  </Wrapper>
);

export default Footer;
